import { createSharedComposable } from "@vueuse/core";
import { ref } from "vue";

const usePreferencesDrawerBase = () => {
    const isPreferencesDrawerOpen = ref(false);

    const openPreferencesDrawer = () => {
        isPreferencesDrawerOpen.value = true;
    };

    const closePreferencesDrawer = () => {
        isPreferencesDrawerOpen.value = false;
    };

    return {
        isPreferencesDrawerOpen,
        openPreferencesDrawer,
        closePreferencesDrawer,
    };
};

export const usePreferencesDrawer = createSharedComposable(
    usePreferencesDrawerBase,
);
